import { ChangeDetectionStrategy, Component, HostListener, input, output } from '@angular/core';
import { TooltipDirective, TooltipPosition } from '../../tooltip/tooltip.directive';
import { TooltipVariant } from '../../tooltip/tooltip';

export type SquareIconBtnVariant = 'default' | 'active' | 'off' | 'danger' | 'success' | 'warning';

@Component({
  selector: 'andor-square-icon-btn',
  standalone: true,
  imports: [TooltipDirective],
  templateUrl: './square-icon-btn.html',
  styleUrl: './square-icon-btn.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SquareIconBtn {
  tooltip = input<string>('');
  tooltipTitle = input<string | null>(null);
  tooltipVariant = input<TooltipVariant>('default');
  tooltipPosition = input<TooltipPosition>('above');
  // E.g. while a menu opened by this button covers the tooltip's spot.
  tooltipDisabled = input<boolean>(false);
  disabled = input<boolean>(false);
  variant = input<SquareIconBtnVariant>('default');
  ariaLabel = input<string>('');
  type = input<'button' | 'submit'>('button');

  clicked = output<MouseEvent>();

  @HostListener('click', ['$event'])
  onHostClick(event: MouseEvent) {
    if (this.disabled()) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  protected onClick(event: MouseEvent) {
    if (this.disabled()) return;
    this.clicked.emit(event);
  }
}
